import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLogin } from 'login/hooks/useLogin';
import { Common } from 'common/services/common.service';
import { AppLoading } from 'common/components/appLoading/appLoading';
import './NewUserNoPassword.scss';

export function NewUserNoPassword() {
  const {
    isLoading,
    isValidUser,
    validateUser
  } = useLogin();

  useEffect(() => {
    const ref = Common.getParamFromUrl('ref');
    if (ref && isValidUser === null) {
      validateUser(ref);
    }
  }, [validateUser, isValidUser]);

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="loading-state">
          <AppLoading size="small" />
          <p>Activating your account...</p>
        </div>
      );
    }

    if (isValidUser === false) {
      return (
        <div className="error-state">
          <h6>Activation Failed</h6>
          <p>Invalid activation link. Please contact support.</p>
        </div>
      );
    }

    if (isValidUser === true) {
      return (
        <div className="success-state">
          <h6>Your user has been activated!</h6>
          <Link to="/login" className="login-link">
            Go to Login
          </Link>
        </div>
      );
    }

    return (
      <div className="loading-state">
        <AppLoading size="small" />
        <p>Processing activation...</p>
      </div>
    );
  };

  return (
    <div className="NewUserNoPassword">
      <img src="/assets/images/logo-ionix-black.svg" alt="Logo" />
      <div className="main-content-area">
        {renderContent()}
      </div>
      <div className="bottom">
        <div className="support">
          For general assistance please contact our <a href="mailto:support@ionix.io">support team</a>
        </div>
      </div>
    </div>
  );
}
